import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';

const ShowConfirmationNumberCell: FC<GridCellProps> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style }) => {
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected={isSelected}
      data-grid-col-index={columnIndex}
      style={{ ...style, textAlign: 'right' }}
    >
      <a className="text-link" rel="noreferrer noopener" href="#" onClick={() => submitCventPost(dataItem.showId, dataItem.companyUserId, dataItem.confirmationNumber)}>
        {dataItem.confirmationNumber}
      </a>
    </td>
  );
};

export default ShowConfirmationNumberCell;

function submitCventPost(showId: string, companyuserId: number, confirmationNumber: string) {
  navigator.clipboard.writeText(confirmationNumber);
  window.open(`https://www.bfgsupply.com/MyAccount/ShowRegistration/Cvent?companyUserId=${companyuserId}&showId=${showId}`, '_blank');
}
